module.exports = __webpack_public_path__ + "img/walletcard_bg.416cf027.png";